"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _TemplateContainer = _interopRequireDefault(require("./TemplateContainer"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MoveContainer = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function MoveContainer() {
    var _this;
    (0, _classCallCheck2["default"])(this, MoveContainer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, MoveContainer, [].concat(args));
    (0, _defineProperty2["default"])(_this, "_templateContainer", /*#__PURE__*/React.createRef());
    (0, _defineProperty2["default"])(_this, "_el", /*#__PURE__*/React.createRef());
    (0, _defineProperty2["default"])(_this, "_dragHandleProps", _this.props.makeDragHandleProps(function () {
      return _this.props.y;
    }));
    return _this;
  }
  (0, _inherits2["default"])(MoveContainer, _React$Component);
  return (0, _createClass2["default"])(MoveContainer, [{
    key: "getDOMNode",
    value: function getDOMNode() {
      return this._el.current;
    }
  }, {
    key: "getTemplate",
    value: function getTemplate() {
      return this._templateContainer.current.getTemplate();
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return this.props.anySelected !== nextProps.anySelected || this.props.itemSelected !== nextProps.itemSelected || this.props.item !== nextProps.item || this.props.template !== nextProps.template || this.props.y !== nextProps.y || this.props.height !== nextProps.height || this.props.zIndex !== nextProps.zIndex || this.props.commonProps !== nextProps.commonProps;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        item = _this$props.item,
        y = _this$props.y,
        padding = _this$props.padding,
        itemSelected = _this$props.itemSelected,
        anySelected = _this$props.anySelected,
        height = _this$props.height,
        zIndex = _this$props.zIndex,
        template = _this$props.template,
        commonProps = _this$props.commonProps;
      return /*#__PURE__*/React.createElement("div", {
        ref: this._el,
        style: {
          position: y == null ? 'relative' : 'absolute',
          boxSizing: 'border-box',
          left: '0px',
          right: '0px',
          top: y == null ? '0px' : "".concat(y, "px"),
          marginBottom: "".concat(padding, "px"),
          height: y == null ? 'auto' : "".concat(anySelected * (height.drag - height.natural) + height.natural, "px"),
          zIndex: zIndex
        }
      }, /*#__PURE__*/React.createElement(_TemplateContainer["default"], {
        ref: this._templateContainer,
        item: item,
        template: template,
        itemSelected: itemSelected,
        anySelected: anySelected,
        dragHandleProps: this._dragHandleProps,
        commonProps: commonProps
      }));
    }
  }]);
}(React.Component);
module.exports = exports.default;
module.exports.default = exports.default;
//# sourceMappingURL=MoveContainer.js.map